import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { VideoPlaylist } from './types'

export const VIDEO_PLAYLISTS_QUERY: TypedDocumentNode<
  { videoPlaylists: VideoPlaylist[] },
  { clientId: string; applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query VideoPlaylists($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    videoPlaylists(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id name description observations synchronized_at created_at updated_at
    }
  }
`

export const VIDEO_PLAYLIST_QUERY: TypedDocumentNode<
  { videoPlaylist: VideoPlaylist | null },
  { id: string }
> = gql`
  query VideoPlaylist($id: ID!) {
    videoPlaylist(id: $id) {
      id client_id application_id name description observations synchronized_at created_at updated_at
    }
  }
`
